import { routes } from "@/routes/config";
import { useStore } from "@/store";
import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement, useEffect } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import classes from "./App.module.scss";
import { Loader } from "./components";

const router = createBrowserRouter(routes);

export const App: FunctionComponent<{}> = observer((): ReactElement<{}> => {
  const store = useStore();

  useEffect((): void => {
    store.app.launch();
  }, []);

  if (store.app.loading) {
    return <Loader className={classes.Loader} />;
  }

  return <RouterProvider router={router} />;
});
